import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"

/**
 * Separator component for visual dividers
 */
const separatorVariants = cva(
    "shrink-0 bg-border",
    {
        variants: {
            orientation: {
                horizontal: "h-[1px] w-full",
                vertical: "h-full w-[1px]",
            },
            spacing: {
                none: "",
                sm: "",
                md: "",
                lg: "",
            },
        },
        compoundVariants: [
            {
                orientation: "horizontal",
                spacing: "sm",
                className: "my-sm",
            },
            {
                orientation: "horizontal",
                spacing: "md",
                className: "my-md",
            },
            {
                orientation: "horizontal",
                spacing: "lg",
                className: "my-lg",
            },
            {
                orientation: "vertical",
                spacing: "sm",
                className: "mx-sm",
            },
            {
                orientation: "vertical",
                spacing: "md",
                className: "mx-md",
            },
            {
                orientation: "vertical",
                spacing: "lg",
                className: "mx-lg",
            },
        ],
        defaultVariants: {
            orientation: "horizontal",
            spacing: "md",
        },
    }
)

const Separator = React.forwardRef(
    ({ className, orientation, spacing, decorative = true, ...props }, ref) => (
        <div
            ref={ref}
            role={decorative ? "none" : "separator"}
            aria-orientation={orientation}
            className={cn(separatorVariants({ orientation, spacing }), className)}
            {...props}
        />
    )
)
Separator.displayName = "Separator"

export { Separator }
